// CAPTCHA protects public form submissions; management APIs enforce authorization.
const submissionPaths = new Set([
  "/api/contact",
  "/api/leads",
  "/api/event-form/submit",
  "/api/auth/signup",
  "/api/auth/prepare-signin",
  "/api/auth/request-otp",
  "/api/auth/reset-password",
  "/api/auth/send-verification",
]);

export function requiresCaptcha(pathname: string, method: string) {
  return (
    method.toUpperCase() === "POST" &&
    submissionPaths.has(pathname.replace(/\/+$/, ""))
  );
}
